import { Box } from '@mui/material';
import FullscreenSwitcher from './FullScreenSwitcher';
import LanguageSwitcher from './LanguageSwitcher';
import ThemeToggle from './ThemeToggle';

function HeaderButtons() {
  return (
    <Box display="flex" alignItems="center">
      <ThemeToggle />
      <FullscreenSwitcher />
      <LanguageSwitcher />
    </Box>
  );
}

export default HeaderButtons;
